export function contruirKeysFromData(data) {
  let dataKeys = {};
  data.map(
    (etapa) =>
      (dataKeys[etapa.indexEtapa || "e" + etapa.idetapa] = etapa.tarjetas.map(
        (tarjeta) => tarjeta.indexTarjeta || "t" + tarjeta.idtarjeta
      ))
  );

  return dataKeys;
}

function getArraysAllData(data) {
  let etapas = [];
  let tarjetas = [];

  data.forEach(etapasArray => {
    etapas.push(etapasArray);
    etapasArray?.tarjetas?.forEach(tarjetasArray => {
      tarjetas.push(tarjetasArray);
    })
  });

  return { etapasArray: etapas, tarjetasArray: tarjetas }
}

export function keysToData(keys, data) {
  let dataArrays = getArraysAllData(data);
  let etapasArray = dataArrays.etapasArray;
  let tarjetasArray = dataArrays.tarjetasArray;
  let nuevaEstructura = [];

  let arrayKeys  = Object.keys(keys);

  arrayKeys.forEach(keyIndex => {
    let etapaToPush = etapasArray.find(etapa => etapa.indexEtapa == keyIndex);
    let tarjetasKeys = keys[keyIndex]
    let tarjetasObjects = [];

    tarjetasKeys.forEach(keyIndexTarjeta => {
      let tarjetaToPush = tarjetasArray.find(tarjeta => tarjeta.indexTarjeta == keyIndexTarjeta);
      tarjetasObjects.push(tarjetaToPush);
    });

    etapaToPush.tarjetas = tarjetasObjects;
    nuevaEstructura.push(etapaToPush);
  });

  return nuevaEstructura;
}
